export interface Category {
  id: string;
  name: string;
  namePt: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: "shoes",
    name: "Shoes",
    namePt: "Calçados",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Side%20angle%20product%20photography%20of%20premium%20white%20leather%20sneakers%20placed%20on%20light%20grey%20concrete%20studio%20floor%2C%20dramatic%20side%20lighting%20casting%20long%20shadows%2C%20commercial%20fashion%20photography%20style%2C%20sharp%20details%20on%20stitching%20and%20texture%2C%20clean%20minimal%20composition%20with%20negative%20space&width=800&height=600&seq=cat-shoes-v2-a01&orientation=landscape",
  },
  {
    id: "hoodies",
    name: "Hoodies/Sweaters",
    namePt: "Moletons",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20photography%20of%20olive%20green%20oversized%20hoodie%20sweatshirt%20spread%20on%20light%20wooden%20floorboards%2C%20morning%20sunlight%20streaming%20from%20window%2C%20cozy%20lifestyle%20aesthetic%2C%20textile%20texture%20visible%2C%20warm%20earthy%20color%20palette%2C%20relaxed%20composition&width=600&height=400&seq=cat-hoodies-v2-a02&orientation=landscape",
  },
  {
    id: "tshirts",
    name: "T-Shirts",
    namePt: "Camisetas",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Three%20folded%20cotton%20t-shirts%20in%20black%20white%20and%20terracotta%20stacked%20on%20marble%20surface%2C%20studio%20lighting%20from%20above%2C%20fabric%20texture%20detail%2C%20minimalist%20retail%20display%20style%2C%20clean%20crisp%20composition%2C%20high%20contrast%20shadows&width=600&height=400&seq=cat-tshirts-v2-a03&orientation=landscape",
  },
  {
    id: "jackets",
    name: "Jackets",
    namePt: "Jaquetas",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Denim%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%20against%20off%20white%20textured%20wall%2C%20soft%20diffused%20natural%20light%2C%20front%20facing%20product%20shot%2C%20editorial%20fashion%20catalog%20style%2C%20visible%20denim%20texture%20and%20stitching%2C%20clean%20commercial%20look&width=600&height=400&seq=cat-jackets-v2-a04&orientation=landscape",
  },
  {
    id: "pants",
    name: "Pants/Shorts",
    namePt: "Calças/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Khaki%20chino%20pants%20and%20denim%20shorts%20laid%20side%20by%20side%20on%20light%20oak%20table%2C%20top%20down%20flat%20lay%2C%20bright%20natural%20daylight%2C%20catalog%20product%20photography%2C%20fabric%20detail%20visible%2C%20organized%20minimal%20composition%20with%20copy%20space&width=600&height=400&seq=cat-pants-v2-a05&orientation=landscape",
  },
  {
    id: "headwear",
    name: "Headwear",
    namePt: "Chapéus/Bonés",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Baseball%20cap%20and%20bucket%20hat%20displayed%20on%20minimal%20white%20pedestal%20stand%2C%20studio%20product%20photography%20with%20soft%20fill%20light%2C%20front%20and%20side%20view%2C%20textured%20fabric%20details%2C%20clean%20commercial%20ecommerce%20style%2C%20neutral%20grey%20backdrop&width=600&height=400&seq=cat-headwear-v2-a06&orientation=landscape",
  },
  {
    id: "sets",
    name: "Sets",
    namePt: "Conjuntos",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20hoodie%20and%20jogger%20set%20displayed%20on%20minimalist%20clothing%20rack%2C%20soft%20studio%20lighting%2C%20slight%20angle%20perspective%2C%20athleisure%20fashion%20photography%2C%20monochromatic%20grey%20outfit%2C%20contemporary%20streetwear%20aesthetic%2C%20clean%20uncluttered%20background&width=600&height=400&seq=cat-sets-v2-a07&orientation=landscape",
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePt: "Roupa Íntima",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20neatly%20folded%20in%20organized%20rows%20on%20light%20linen%20fabric%20surface%2C%20gentle%20morning%20light%2C%20overhead%20flat%20lay%2C%20pastel%20color%20palette%2C%20minimalist%20intimate%20apparel%20photography%2C%20clean%20fresh%20composition%20with%20fabric%20texture&width=600&height=400&seq=cat-underwear-v2-a08&orientation=landscape",
  },
  {
    id: "jersey",
    name: "Jersey",
    namePt: "Camisas de Time",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Football%20soccer%20jersey%20with%20vibrant%20team%20colors%20displayed%20on%20dark%20slate%20surface%2C%20dramatic%20spotlight%20lighting%2C%20angled%20perspective%20showing%20badge%20and%20sponsor%20details%2C%20sports%20merchandise%20photography%2C%20dynamic%20composition%2C%20premium%20product%20presentation&width=600&height=400&seq=cat-jersey-v2-a09&orientation=landscape",
  },
  {
    id: "accessories",
    name: "Accessories",
    namePt: "Acessórios",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20sunglasses%20and%20minimalist%20watch%20arranged%20on%20smooth%20grey%20stone%20surface%2C%20side%20lighting%20creating%20elegant%20highlights%2C%20luxury%20accessories%20product%20photography%2C%20metallic%20reflections%2C%20refined%20editorial%20composition%2C%20sophisticated%20modern%20aesthetic&width=600&height=400&seq=cat-accessories-v2-a10&orientation=landscape",
  },
  {
    id: "bags",
    name: "Bags",
    namePt: "Bolsas",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Taupe%20leather%20tote%20bag%20standing%20upright%20on%20light%20terrazzo%20surface%2C%20natural%20window%20light%20from%20left%2C%20three%20quarter%20angle%20product%20shot%2C%20fashion%20accessories%20photography%2C%20visible%20leather%20grain%20and%20gold%20hardware%2C%20elegant%20minimal%20composition&width=600&height=400&seq=cat-bags-v2-a11&orientation=landscape",
  },
  {
    id: "belts",
    name: "Belts",
    namePt: "Cintos",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20genuine%20leather%20belts%20one%20brown%20one%20black%20elegantly%20curled%20on%20smooth%20white%20ceramic%20surface%2C%20soft%20studio%20lighting%2C%20close%20up%20showing%20buckle%20and%20stitching%20detail%2C%20fashion%20accessories%20product%20photography%2C%20minimal%20luxury%20presentation&width=600&height=400&seq=cat-belts-v2-a12&orientation=landscape",
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePt: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20fragrance%20bottle%20with%20amber%20liquid%20on%20dark%20walnut%20wood%20surface%2C%20dramatic%20side%20lighting%20with%20warm%20golden%20glow%2C%20premium%20perfume%20product%20photography%2C%20glass%20reflections%20and%20shadows%2C%20sophisticated%20beauty%20campaign%20style%2C%20rich%20contrast&width=600&height=400&seq=cat-perfumes-v2-a13&orientation=landscape",
  },
  {
    id: "otherstuff",
    name: "OtherStuff",
    namePt: "Outros Itens",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20lifestyle%20items%20including%20wallet%20keychain%20and%20phone%20case%20arranged%20on%20light%20cork%20surface%2C%20overhead%20knolling%20flat%20lay%2C%20bright%20even%20lighting%2C%20organized%20grid%20composition%2C%20modern%20minimalist%20product%20photography%2C%20clean%20ecommerce%20style&width=600&height=400&seq=cat-other-v2-a14&orientation=landscape",
  },
];